module.exports = __webpack_public_path__ + "static/saltaire3@abonventre.11e896bf.jpg";